// @ts-ignore
import * as moment from 'moment';

export function todayMidnight() {
  return moment().startOf('day');
}
